export const isSmallScreen = window.innerWidth < 500
